export const LEFT_CONTENT = {
	DESCRIPTION: "titleAndDescriptionWithLink",
	IMAGE: "Image",
	LEANER_IMAGE: "leanerImage",
	PRICE_CARD: "priceCard",
};
